module.exports = __webpack_public_path__ + "static/media/portfolio1 (42).5dc35426.jpeg";